import { v4 as uuidv4 } from 'uuid';

import { ROUTES, ROLES } from 'config/constants';

export const configMobileMenu = (userRole, id) => {
  switch (userRole) {
    case ROLES.RESEARCH_SITE:
      return [
        {
          id: uuidv4(),
          title: 'Sponsors',
          childrens: [
            {
              id: uuidv4(),
              route: ROUTES.SPONSORS,
              title: 'All Sponsors',
            },
            {
              id: uuidv4(),
              route: ROUTES.MY_SPONSORS,
              title: 'My Sponsors',
            },
            {
              id: uuidv4(),
              route: ROUTES.SPONSOR_PROFILE_REQUESTS,
              title: 'Sponsor Connection Requests',
            },
          ],
        },
        {
          id: uuidv4(),
          title: 'Studies',
          route: ROUTES.ALL_STUDIES,
        },
        {
          id: uuidv4(),
          title: 'Applications',
          route: ROUTES.APPLICATIONS_BY_RESEARCH_SITE,
        },
        {
          id: uuidv4(),
          title: 'All Research Sites',
          route: ROUTES.RESEARCH_SITES,
        },
        {
          id: uuidv4(),
          title: 'My Patients',
          route: ROUTES.ALL_PATIENTS,
        },
        {
          title: 'Personnel',
          id: uuidv4(),
          childrens: [
            {
              id: uuidv4(),
              route: ROUTES.ALL_PERSONNEL,
              title: 'All Personnel',
            },
            {
              id: uuidv4(),
              route: ROUTES.LINKING_REQUESTS,
              title: 'Linking requests',
            },
          ],
        },
      ];
    case ROLES.SPONSOR:
      return [
        {
          id: uuidv4(),
          title: 'Research Sites',
          childrens: [
            {
              id: uuidv4(),
              route: ROUTES.RESEARCH_SITES,
              title: 'All Research Sites',
            },
            {
              id: uuidv4(),
              route: ROUTES.MY_RESEARCH_SITES,
              title: 'My Research Sites',
            },
            {
              id: uuidv4(),
              route: ROUTES.RESEARCH_SITE_PROFILE_REQUESTS,
              title: 'Site Connection Requests',
            },
          ],
        },
        {
          id: uuidv4(),
          title: 'Studies',
          route: ROUTES.ALL_STUDIES,
        },
        {
          id: uuidv4(),
          title: 'Applications',
          route: `${ROUTES.APPLICATIONS_BY_SPONSOR}/${id}`,
        },
        {
          title: 'Personnel',
          id: uuidv4(),
          childrens: [
            {
              id: uuidv4(),
              route: ROUTES.ALL_PERSONNEL,
              title: 'All Personnel',
            },
            {
              id: uuidv4(),
              route: ROUTES.LINKING_REQUESTS,
              title: 'Linking requests',
            },
          ],
        },
      ];
    case ROLES.PERSONNEL:
      return [
        {
          id: uuidv4(),
          route: ROUTES.SPONSORS,
          title: 'Sponsors',
        },
        {
          id: uuidv4(),
          title: 'Studies',
          route: ROUTES.ALL_STUDIES,
        },
        {
          id: uuidv4(),
          title: 'All Research Sites',
          route: ROUTES.RESEARCH_SITES,
        },
        {
          id: uuidv4(),
          route: ROUTES.LINKING_REQUESTS,
          title: 'Linking requests',
        },
      ];
    case ROLES.SPONSOR_PERSONNEL:
      return [
        {
          id: uuidv4(),
          title: 'Research Sites',
          childrens: [
            {
              id: uuidv4(),
              route: ROUTES.RESEARCH_SITES,
              title: 'All Research Sites',
            },
            {
              id: uuidv4(),
              route: ROUTES.MY_RESEARCH_SITES,
              title: 'My Research Sites',
            },
            {
              id: uuidv4(),
              route: ROUTES.RESEARCH_SITE_PROFILE_REQUESTS,
              title: 'Site Connection Requests',
            },
          ],
        },
        {
          id: uuidv4(),
          title: 'Applications',
          route: `${ROUTES.APPLICATIONS_BY_SPONSOR}/${id}`,
        },
        {
          id: uuidv4(),
          title: 'Studies',
          route: ROUTES.ALL_STUDIES,
        },
      ];
    case ROLES.RESEARCH_SITE_PERSONNEL:
      return [
        {
          id: uuidv4(),
          title: 'Sponsors',
          childrens: [
            {
              id: uuidv4(),
              route: ROUTES.SPONSORS,
              title: 'All Sponsors',
            },
            {
              id: uuidv4(),
              route: ROUTES.MY_SPONSORS,
              title: 'My Sponsors',
            },
            {
              id: uuidv4(),
              route: ROUTES.SPONSOR_PROFILE_REQUESTS,
              title: 'Sponsor Connection Requests',
            },
          ],
        },
        {
          id: uuidv4(),
          title: 'Applications',
          route: `${ROUTES.APPLICATIONS_BY_RESEARCH_SITE}/${id}`,
        },
        {
          id: uuidv4(),
          title: 'Studies',
          route: ROUTES.ALL_STUDIES,
        },
        {
          id: uuidv4(),
          route: ROUTES.RESEARCH_SITES,
          title: 'All Research Sites',
        },
        {
          id: uuidv4(),
          title: 'My Patients',
          route: ROUTES.ALL_PATIENTS,
        },
      ];
    default:
      return [];
  }
};
